// layout
import layoutHeaderAside from '@/index/layout/header-aside'

const meta = { requiresAuth: true }

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/operate',
    redirect: { name: 'operateHome' },
    component: layoutHeaderAside,
    children: [
      // 首页
      {
        path: '/operate/home',
        name: 'operateHome',
        redirect: { name: 'operateHomeTotal' },
        component: () => import('@/index/pages/operate/home'),
        meta: { meta, title: '首页' },
        children: [
          {
            path: 'total',
            name: 'operateHomeTotal',
            component: () => import('@/index/pages/operate/home/total'),
            meta: { meta, title: '首页' }
          },
          {
            path: 'bill',
            name: 'operateHomeBill',
            component: () => import('@/index/pages/operate/home/bill'),
            meta: { meta, title: '首页' }
          },
          {
            path: 'goods',
            name: 'operateHomeGoods',
            component: () => import('@/index/pages/operate/home/goods'),
            meta: { meta, title: '首页' }
          }
        ]
      },
      // 配送管理
      {
        path: '/operate/purchase',
        name: 'operatePurchase',
        redirect: { name: 'operatePurchaseTabs' },
        component: () => import('@/index/pages/operate/purchase'),
        meta: { meta, title: '配送管理' },
        children: [
          {
            path: 'tabs',
            name: 'operatePurchaseTabs',
            component: () => import('@/index/pages/operate/purchase/purchaseTabs'),
            meta: { meta, title: '配送管理' }
          },
          {
            path: 'addPointLocation',
            name: 'operateAddPointLocation',
            component: () => import('@/index/pages/operate/purchase/addPointLocation'),
            meta: { meta, title: '新建取货地址' }
          },
          {
            path: 'editPointLocation/:locationId',
            name: 'operateEditPointLocation',
            component: () => import('@/index/pages/operate/purchase/editPointLocation'),
            meta: { meta, title: '修改取货地址' }
          }
        ]
      },
      // 订单管理
      /**/
      {
        path: '/operate/order',
        name: 'operateOrder',
        redirect: { name: 'operateOrderTabs' },
        component: () => import('@/index/pages/operate/order'),
        meta: { meta, title: '订单管理' },
        children: [
          {
            path: 'tabs',
            name: 'operateOrderTabs',
            component: () => import('@/index/pages/operate/order/orderTabs'),
            meta: { meta, title: '订单管理' }
          }
        ]
      },
      // 商品管理
      {
        path: '/operate/goods',
        name: 'operateGoods',
        redirect: { name: 'operateGoodsTabs' },
        component: () => import('@/index/pages/operate/goods'),
        meta: { meta, title: '商品管理' },
        children: [
          {
            path: 'tabs',
            name: 'operateGoodsTabs',
            component: () => import('@/index/pages/operate/goods/goodsTabs'),
            meta: { meta, title: '商品管理' }
          },
          {
            path: 'addGoods',
            name: 'operateGoodsAddGoods',
            component: () => import('@/index/pages/operate/goods/addGoods'),
            meta: { meta, title: '新建商品' }
          },
          {
            path: 'updateGoods/:goodsId',
            name: 'operateGoodsUpdateGoods',
            component: () => import('@/index/pages/operate/goods/updateGoods'),
            meta: { meta, title: '修改商品' }
          }
        ]
      },
      // 消息
      {
        path: '/operate/msg',
        name: 'operateMsg',
        redirect: { name: 'operateMsgTabs' },
        component: () => import('@/index/pages/operate/msg'),
        meta: { meta, title: '消息' },
        children: [
          {
            path: 'tabs',
            name: 'operateMsgTabs',
            component: () => import('@/index/pages/operate/msg/msgTabs'),
            meta: { meta, title: '消息' }
          }
        ]
      },
      // 云库存
      {
        path: '/operate/cloud',
        name: 'operateCloud',
        redirect: { name: 'operateTestD2One' },
        component: () => import('@/index/pages/operate/cloud/index'),
        meta: { meta, title: '云库存' },
        children: [
          {
            path: 'd2One',
            name: 'operateTestD2One',
            component: () => import('@/index/pages/operate/cloud/d2One') ,
            meta: { meta, title: '云库存' },
          },
          {
            path: 'msg',
            name: 'msg',
            component: () => import('@/index/pages/operate/cloud/d2One/msg.vue') ,
            meta: { meta, title: '云库存/店铺采购' },
          },
          {
            path: 'alterMsg',
            name: 'alterMsg',
            component: () => import('@/index/pages/operate/cloud/d2One/alterMsg.vue') ,
            meta: { meta, title: '云库存/修改店铺信息' },
          },
          {
            path: 'alterDetail',
            name: 'alterDetail',
            component: () => import('@/index/pages/operate/cloud/d2One/alterDetail.vue') ,
            meta: { meta, title: '云库存/返现详细信息' },
          },
        ]
      },
      // 供应商首页
      {
        path: '/operate/supplier/home',
        name: 'home',
        redirect: { name: 'homePage' },
        component: () => import('@/index/pages/operate/supplier/home'),
        meta: { meta, statue: true, title: '首页' },
        children: [
          {
            path: '/homePage',
            name: 'homePage',
            component: () => import('@/index/pages/operate/supplier/home/router_link/homePage.vue'),
            meta: { meta, statue: true, title: '首页' },
          },
          {
            path: '/homeAmend',
            name: 'homeAmend',
            component: () => import('@/index/pages/operate/supplier/home/router_link/amend.vue'),
            meta: { meta, statue: true, title: '首页/添加店铺信息' },
          },
          {
            path: '/homeDetails',
            name: 'details',
            component: () => import('@/index/pages/operate/supplier/home/router_link/details.vue'),
            meta: { meta, statue: true, title: '首页/店铺信息' },
          },
          {
            path: '/homeMsgAmend',
            name: 'msgAmend',
            component: () => import('@/index/pages/operate/supplier/home/router_link/msgAmend.vue'),
            meta: { meta, statue: true, title: '首页/修改店铺信息' },
          },
        ],
      },
      // 供应商商品管理
      {
        path: '/operate/supplier/goods',
        name: 'goods',
        component: () => import('@/index/pages/operate/supplier/goods'),
        meta: { meta, statue: true, title: '商品管理' },
      },
      // 供应商订单管理
      {
        path: '/operate/supplier/order',
        name: 'order',
        redirect: { name: 'orderIndex' },
        component: () => import('@/index/pages/operate/supplier/order'),
        meta: { meta, statue: true, title: '订单管理' },
        children: [
          {
            path: '/index', 
            name: 'orderIndex',
            component: () => import('@/index/pages/operate/supplier/order/router_link/index.vue'),
            meta: { meta, statue: true, title: '订单管理' },
          },
          {
            path: '/addOrder',
            name: 'addOrder',
            component: () => import('@/index/pages/operate/supplier/order/router_link/addOrder.vue'),
            meta: { meta, statue: true, title: '新建订单' },
          },
        ],
      },
      // 供应商配送管理
      // {
        // path: '/operate/supplier/send',
        // name: 'send',
        // component: () => import('@/index/pages/operate/supplier/send'),
        // meta: { meta, statue: true, title: '配送管理' }
        // redirect: [{ name: 'operateHome' }],
      // },
      // 供应商人员管理
      {
        path: '/operate/supplier/staff',
        name: 'staff',
        component: () => import('@/index/pages/operate/supplier/staff'),
        meta: { meta, statue: true, title: '人员管理' }
        // redirect: [{ name: 'operateHome' }],
      },
    ]
  },
]

/**
 * 在主框架之外显示
 */
const frameOut = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/index/pages/login'),
    meta: { meta, title: '登录' }
  },
  // 登陆
  {
    path: '/',
    name: 'login',
    component: () => import('@/index/pages/login'),
    meta: { meta, title: '登录' }
  }
]

/**
 * 错误页面
 */
const errorPage = [
  // 404
  {
    path: '*',
    name: '404',
    component: () => import('@/index/pages/error-page-404'),
    meta: { meta, title: '页面没找到' }
  }
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  ...errorPage
]
